<div class="campanha-pipeline-card-info-status">
    <!-- Não Confirmada -->
    <sgt-campanha-pipeline-card-info-nao-confirmada
        *ngIf="config?.isNaoConfirmada"
        [createdAt]="campanha.createdAt"
        [idUsuarioCreated]="campanha.idUsuarioCreated"
        [avatarURLUsuarioCreated]="campanha.avatarURLUsuarioCreated"
        [nomeUsuarioCreated]="campanha.nomeUsuarioCreated">
    </sgt-campanha-pipeline-card-info-nao-confirmada>

    <!-- Em Análise -->
    <sgt-campanha-pipeline-card-info-em-analise
        *ngIf="config?.isEmAnalise"
        [dataSolicitacaoAnalise]="campanha.dataSolicitacaoAnalise"
        [idUsuarioSolicitacaoAnalise]="campanha.idUsuarioSolicitacaoAnalise"
        [avatarURLUsuarioSolicitacaoAnalise]="campanha.avatarURLUsuarioSolicitacaoAnalise"
        [nomeUsuarioSolicitacaoAnalise]="campanha.nomeUsuarioSolicitacaoAnalise">
    </sgt-campanha-pipeline-card-info-em-analise>

    <!-- Vigência -->
    <sgt-campanha-pipeline-card-info-vigencia
        [isNaoConfirmada]="config?.isNaoConfirmada"
        [isEmAnalise]="config?.isEmAnalise"
        [isEmAndamento]="config?.isEmAndamento"
        [isEmRevisao]="config?.isEmRevisao"
        [isEncerrada]="config?.isEncerrada"
        [isReprovada]="config?.isReprovada"
        [sobDemandaPacoteCampanha]="campanha.sobDemandaPacoteCampanha"
        [vigenciaRecorrente]="campanha.vigenciaRecorrente"
        [quantidadeDiasVigencia]="campanha.quantidadeDiasVigencia"
        [dataTerminoVigencia]="campanha.dataTerminoVigencia"
        [dataInicioAndamento]="campanha.dataInicioAndamento"
        [dataTerminoAndamento]="campanha.dataTerminoAndamento">
    </sgt-campanha-pipeline-card-info-vigencia>

    <!-- Reprovada -->
    <sgt-campanha-pipeline-card-info-reprovada
        *ngIf="config?.isReprovada"
        [dataAnalise]="campanha.dataAnalise"
        [idUsuarioAnalise]="campanha.idUsuarioAnalise"
        [avatarURLUsuarioAnalise]="campanha.avatarURLUsuarioAnalise"
        [nomeUsuarioAnalise]="campanha.nomeUsuarioAnalise"
        [justificativaAnalise]="campanha.justificativaAnalise">
    </sgt-campanha-pipeline-card-info-reprovada>
</div>